module.exports = __webpack_public_path__ + "static/img/img-coupon-list03.7d631d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-coupon-list03.png
// module id = ered
// module chunks = 1